// Initialize Values
export const INITIALIZE_VALUES_SHIPMENT_LEVEL =
  "INITIALIZE_VALUES_SHIPMENT_LEVEL";
  export const UPDATE_WAIVER_STATUS =
  "UPDATE_WAIVER_STATUS";
  export const SAVE_WAIVER_STATUS =
  "SAVE_WAIVER_STATUS";
export const INITIALIZE_VALUES_TRANSACTION_NO =
  "INITIALIZE_VALUES_TRANSACTION_NO";
export const INITIALIZE_VALUES_CARGO_CONTROL_NO =
  "INITIALIZE_VALUES_CARGO_CONTROL_NO";
export const INITIALIZE_VALUES_IMPORTER = "INITIALIZE_VALUES_IMPORTER";
export const INITIALIZE_VALUES_DESCRIPTION_OF_INVOICE =
  "INITIALIZE_VALUES_DESCRIPTION_OF_INVOICE";
export const INITIALIZE_VALUES_DESCRIPTION_OF_MERCHANDISE =
  "INITIALIZE_VALUES_DESCRIPTION_OF_MERCHANDISE";
export const INITIALIZE_VALUES_DECLARATION_SECTION =
  "INITIALIZE_VALUES_DECLARATION_SECTION";
export const INITIALIZE_VALUES_FIELD_VALIDATION =
  "INITIALIZE_VALUES_FIELD_VALIDATION";
export const INITIALIZE_WARNINGS = "INITIALIZE_WARNINGS";
export const INITIALIZE_DROPDOWNS = "INITIALIZE_DROPDOWNS";
export const INITIALIZE_SHIPID = "INITIALIZE_SHIPID";

export const INITIALIZE_VALUES_TC = (lineItemIndex) =>
  `INITIALIZE_VALUES_TC_${lineItemIndex}`;
export const INITIALIZE_VALUES_ECCC = (lineItemIndex) =>
  `INITIALIZE_VALUES_ECCC_${lineItemIndex}`;
export const INITIALIZE_INVOICE_VALUES_ECCC = (lineItemIndex) =>
  `INITIALIZE_INVOICE_VALUES_ECCC_${lineItemIndex}`;

export const INITIALIZE_VALUES_CFIA = (lineItemIndex) =>
  `INITIALIZE_VALUES_CFIA_${lineItemIndex}`;
export const INITIALIZE_VALUES_CNSC = (merchID) =>
  `INITIALIZE_VALUES_CNSC_${merchID}`;
export const INITIALIZE_VALUES_NRCAN = (lineItemIndex) =>
  `INITIALIZE_VALUES_NRCAN_${lineItemIndex}`;
export const INITIALIZE_VALUES_GAC = (lineItemIndex) =>
  `INITIALIZE_VALUES_GAC_${lineItemIndex}`;

export const FORM_LOADED = "FORM_LOADED";
export const INITIALIZE_ECCC_FLAG = "INITIALIZE_ECCC_FLAG";
export const FORM_VALUES = "FORM_VALUES";
export const SET_ANY_FORM_VALUES = "SET_ANY_FORM_VALUES";
export const SET_ERROR_MESSAGE = "SET_ERROR_MESSAGE";

export const UPDATE_CARGO_CONTROL_NUMBER_FIELD =
  "UPDATE_CARGO_CONTROL_NUMBER_FIELD";
export const SAVE_CARGO_CONTROL_NUMBER_FIELD =
  "SAVE_CARGO_CONTROL_NUMBER_FIELD";

// DeclarationSectionActions
export const UPDATE_DECLARATION_SECTION_FIELD =
  "UPDATE_DECLARATION_SECTION_FIELD";
export const SAVE_DECLARATION_SECTION_FIELD = "SAVE_DECLARATION_SECTION_FIELD";

// DescriptionOfInvoiceActions
export const UPDATE_INVOICE_ITEM_FIELD = "UPDATE_INVOICE_ITEM_FIELD";
export const UPDATE_INVOICE_HEADERPARTY_ITEM =
  "UPDATE_INVOICE_HEADERPARTY_ITEM";
export const UPDATE_INVOICE_ACTOR_ADDRESS = "UPDATE_INVOICE_ACTOR_ADDRESS";
export const ADD_INVOICE_ITEM = "ADD_INVOICE_ITEM";
export const INVOICE_WARNING_ON_ADDITION = "INVOICE_WARNING_ON_ADDITION";
export const REMOVE_INVOICE_ITEM = "REMOVE_INVOICE_ITEM";
export const SAVE_INVOICE_FIELD = "SAVE_INVOICE_FIELD";
export const SAVE_INVOICE_ITEM = "SAVE_INVOICE_ITEM";
// export const SAVE_VENDOR_NAME = 'SAVE_VENDOR_NAME'
// export const SAVE_VENDOR_NUMBER = 'SAVE_VENDOR_NUMBER'
// export const SAVE_VENDOR_ADDRESS = 'SAVE_VENDOR_ADDRESS'
// export const SAVE_HEADER_PARTY_ADDRESS = 'SAVE_HEADER_PARTY_ADDRESS'
export const SAVE_DOI_HEADER_PARTY_NAME = "SAVE_DOI_HEADER_PARTY_NAME";
export const UPDATE_DOI_HEADERPARTY_ITEM = "UPDATE_DOI_HEADERPARTY_ITEM";
export const SAVE_DOI_HEADER_PARTY_ADDRESS = "SAVE_DOI_HEADER_PARTY_ADDRESS";
export const UPDATE_DOI_ACTOR_ADDRESS = "UPDATE_DOI_ACTOR_ADDRESS";
export const SAVE_INVOICE_ITEM_FIELD = "SAVEE_INVOICE_ITEM_FIELD";
export const ADD_MERCH_ID_TO_INVOICE = "ADD_MERCH_ID_TO_INVOICE";
export const REMOVE_MERCH_ID_FROM_INVOICE = "REMOVE_MERCH_ID_FROM_INVOICE";
export const ON_CURRENCY_CODE_OR_DIRECT_SHIPMENT_DATE_CHANGED =
  "ON_CURRENCY_CODE_OR_DIRECT_SHIPMENT_DATE_CHANGED";
export const ON_EXCHANGE_RATE_ON_INVOICE_CHANGED =
  "ON_EXCHANGE_RATE_ON_INVOICE_CHANGED";

// DescriptionOfMerchandiseActions
export const UPDATE_AND_SAVE_TOTALS = "UPDATE_AND_SAVE_TOTALS";
export const UPDATE_HTS_CONTEXT = "UPDATE_HTS_CONTEXT";
export const SAVE_LINE_ITEM_DUTIES = "SAVE_LINE_ITEM_DUTIES";
export const UPDATE_TOTALS = "UPDATE_TOTALS";
export const UPDATE_MERCH_FIELD = "UPDATE_MERCH_FIELD";
export const UPDATE_MERCH_OBJECT = "UPDATE_MERCH_OBJECT";
export const UPDATE_MERCH_LINE_ITEM_FIELD = "UPDATE_MERCH_LINE_ITEM_FIELD";
export const UPDATE_MERCH_LINE_ITEM_OBJECT = "UPDATE_MERCH_LINE_ITEM_OBJECT";
export const ADD_MERCHANDISE_LINE_ITEM = "ADD_MERCHANDISE_LINE_ITEM";
export const REMOVE_MERCHANDISE_LINE_ITEM = "REMOVE_MERCHANDISE_LINE_ITEM";
export const SAVE_MERCHANDISE_FIELD = "SAVE_MERCHANDISE_FIELD";
export const SAVE_MERCHANDISE_LINE_ITEM = "SAVE_MERCHANDISE_LINE_ITEM";
export const SAVE_PGA_DETAILS_LINE_ITEM = "SAVE_PGA_DETAILS_LINE_ITEM";
export const SET_LINE_ITEM = "SET_LINE_ITEM";
export const SET_TOTAL_VALUE_AND_GROSS_WEIGHT =
  "SET_TOTAL_VALUE_AND_GROSS_WEIGHT";

export const UPDATE_LINE_ITEM_WISE_CALCULATION =
  "UPDATE_LINE_ITEM_WISE_CALCULATION";
export const UPDATE_MERCH_LINE_ITEM_PGA_OBJECT =
  "UPDATE_MERCH_LINE_ITEM_PGA_OBJECT";
export const UPDATE_LINE_ITEM_WITH_NEW_PGA = "UPDATE_LINE_ITEM_WITH_NEW_PGA";
export const UPDATE_LINE_ITEM_WITH_PGA_DETAILS =
  "UPDATE_LINE_ITEM_WITH_PGA_DETAILS";
export const UPDATE_TOTAL_VFD_AT_SUBHRD = "UPDATE_TOTAL_VFD_AT_SUBHRD";

export const CALCULATE_AND_UPDATE_CURRENCY_CONVERSION =
  "CALCULATE_AND_UPDATE_CURRENCY_CONVERSION";
export const CALCULATE_AND_UPDATE_VFD = "CALCULATE_AND_UPDATE_VFD";

export const UPDATE_DOM_HEADERPARTY_ITEM = "UPDATE_DOM_HEADERPARTY_ITEM";
export const UPDATE_DOM_ACTOR_ADDRESS = "UPDATE_DOM_ACTOR_ADDRESS";
export const SAVE_DOM_HEADER_PARTY_ADDRESS = "SAVE_DOM_HEADER_PARTY_ADDRESS";
export const SAVE_DOM_HEADER_PARTY_NAME = "SAVE_DOM_HEADER_PARTY_NAME";
export const SAVE_DOM_HEADER_PARTY_NAME_APPLY_ALL = "SAVE_DOM_HEADER_PARTY_NAME_APPLY_ALL"
export const GET_TOTAL_INVOICE_AMT = "GET_TOTAL_INVOICE_AMT";
//PGA
export const ADD_ADDITIONAL_PGA = "ADD_ADDITIONAL_PGA";

// Transaction Number
export const UPDATE_TRANSACTION_NUMBER_FIELD =
  "UPDATE_TRANSACTION_NUMBER_FIELD";
export const SAVE_TRANSACTION_NUMBER_FIELD = "SAVE_TRANSACTION_NUMBER_FIELD";

// EntryTypeActions
export const UPDATE_ENTRY_TYPE_FIELD = "UPDATE_ENTRY_TYPE_FIELD";
export const UPDATE_SUMMARY_DATE_FIELD = "UPDATE_SUMMARY_DATE_FIELD";
export const UPDATE_ENTRY_DATE_FIELD = "UPDATE_ENTRY_DATE_FIELD";
export const UPDATE_FTZ_DATE_FIELD = "UPDATE_FTZ_DATE_FIELD";
export const SAVE_ENTRY_TYPE_FIELD = "SAVE_ENTRY_TYPE_FIELD";
export const SAVE_ENTRY_TYPE_DATE_FIELD = "SAVE_ENTRY_TYPE_DATE_FIELD";
export const UPDATE_ENTRY_TYPE_OBJECT = "UPDATE_ENTRY_TYPE_OBJECT";
export const UPDATE_ENTRY_TYPE_WARNING = "UPDATE_ENTRY_TYPE_WARNING";

// FeildValidationActions
export const UPDATE_FIELD_WARNINGS = "UPDATE_FIELD_WARNINGS";
export const UPDATE_FIELD_VALIDATION_OBJECT = "UPDATE_FIELD_VALIDATION_OBJECT";

// ImporterActions
export const SAVE_IMPORTER_NAME = "SAVE_IMPORTER_NAME";
export const SAVE_IMPORTER_NUMBER = "SAVE_IMPORTER_NUMBER";
export const SAVE_CONSIGNEE_NAME = "SAVE_CONSIGNEE_NAME";
export const SAVE_CONSIGNEE_NUMBER = "SAVE_CONSIGNEE_NUMBER";
export const UPDATE_ACTOR_FIELD = "UPDATE_ACTOR_FIELD";
export const UPDATE_ACTOR_ADDRESS = "UPDATE_ACTOR_ADDRESS";
export const UPDATE_HEADER_PARTY_FIELD = "UPDATE_HEADER_PARTY_FIELD";
export const UPDATE_HEADER_PARTY = "UPDATE_HEADER_PARTY";
export const ADD_HEADER_PARTY = "ADD_HEADER_PARTY";
export const REMOVE_HEADER_PARTY = "REMOVE_HEADER_PARTY";
export const UPDATE_HEADER_PARTY_ADDRESS = "UPDATE_HEADER_PARTY_ADDRESS";
export const UPDATE_FIELD = "UPDATE_FIELD";
export const UPDATE_IMPORTER_FIELD = "UPDATE_IMPORTER_FIELD";
export const SAVE_ACTOR_NAME = "SAVE_ACTOR_NAME";
export const SAVE_ACTOR_ADDRESS = "SAVE_ACTOR_ADDRESS";
export const SAVE_HEADER_PARTIES = "SAVE_HEADER_PARTIES";
export const SAVE_IMPORTER = "SAVE_IMPORTER";
export const SAVE_CONSIGNEE = "SAVE_CONSIGNEE";
export const ADD_MANUFACTURER = "ADD_MANUFACTURER";

// SUBHRD Actions
export const SAVE_SUBHRD_FIELD = "SAVE_SUBHRD_FIELD";
export const INITIALIZE_VALUES_SUBHRD = "INITIALIZE_VALUES_SUBHRD";
export const ADD_NEW_CONTAINER = "ADD_NEW_CONTAINER";
export const REMOVE_CONTAINER = "REMOVE_CONTAINER";
export const UPDATE_CONTAINER_NUMBER_FIELD = "UPDATE_CONTAINER_NUMBER_FIELD";
export const SAVE_CONTAINER_NUMBER_FIELD = "SAVE_CONTAINER_NUMBER_FIELD";
export const UPDATE_CONTAINER_ON_RESPONSE = "UPDATE_CONTAINER_ON_RESPONSE";

//CARGO Actions
export const SAVE_CARGO_SECTION_FIELD = "SAVE_CARGO_SECTION_FIELD";
export const UPDATE_CARGO_SECTION_FIELD = "UPDATE_CARGO_SECTION_FIELD";
export const INITIALIZE_VALUES_CARGO_SECTION =
  "INITIALIZE_VALUES_CARGO_SECTION";

//TOTALS Actions
export const UPDATE_TOTALS_SECTION_FIELD = "UPDATE_TOTALS_SECTION_FIELD";
export const SAVE_TOTALS_SECTION_FIELD = "SAVE_TOTALS_SECTION_FIELD";
export const INITIALIZE_VALUES_TOTALS_SECTION =
  "INITIALIZE_VALUES_TOTALS_SECTION";

// NHTSAActions
export const TOGGLE_TC = (lineItemIndex) => `TOGGLE_TC_${lineItemIndex}`;
export const UPDATE_TC_FIELD = (lineItemIndex) =>
  `UPDATE_TC_FIELD_${lineItemIndex}`;
export const UPDATE_TC_TYPE = (lineItemIndex) =>
  `UPDATE_TC_TYPE_${lineItemIndex}`;
export const SAVE_TC_FIELD = (lineItemIndex) =>
  `SAVE_TC_FIELD_${lineItemIndex}`;

export const TOGGLE_ECCC = (lineItemIndex) => `TOGGLE_ECCC_${lineItemIndex}`;
export const UPDATE_ECCC_FIELD = (lineItemIndex) =>
  `UPDATE_ECCC_FIELD_${lineItemIndex}`;
export const SAVE_ECCC_FIELD = (lineItemIndex) =>
  `SAVE_ECCC_FIELD_${lineItemIndex}`;
export const TOGGLE_INVOICE_ECCC = (lineItemIndex) =>
  `TOGGLE_INVOICE_ECCC_${lineItemIndex}`;
export const UPDATE_INVOICE_ECCC_FIELD = (lineItemIndex) =>
  `UPDATE_INVOICE_ECCC_FIELD_${lineItemIndex}`;
export const SAVE_INVOICE_ECCC_FIELD = (lineItemIndex) =>
  `SAVE_INVOICE_ECCC_FIELD_${lineItemIndex}`;

export const TOGGLE_CFIA = (lineItemIndex) => `TOGGLE_CFIA_${lineItemIndex}`;
export const TOGGLE_CNSC = (merchID) => `TOGGLE_CNSC_${merchID}`;
export const UPDATE_CFIA_FIELD = (lineItemIndex) =>
  `UPDATE_CFIA_FIELD_${lineItemIndex}`;
export const SAVE_CFIA_FIELD = (lineItemIndex) =>
  `SAVE_CFIA_FIELD_${lineItemIndex}`;
export const UPDATE_CNSC_FIELD = (merchID) => `UPDATE_CNSC_FIELD_${merchID}`;
export const SAVE_CNSC_FIELD = (merchID) => `SAVE_CNSC_FIELD_${merchID}`;
export const INITIALIZE_VALUES_CFIA_PAYOR = (lineItemIndex) =>
  `INITIALIZE_VALUES_CFIA_PAYOR_${lineItemIndex}`;
export const TOGGLE_CFIA_PAYOR = (lineItemIndex) =>
  `TOGGLE_CFIA_PAYOR_${lineItemIndex}`;
export const UPDATE_CFIA_FIELD_PAYOR = (lineItemIndex) =>
  `UPDATE_CFIA_FIELD_PAYOR_${lineItemIndex}`;
export const SAVE_CFIA_FIELD_PAYOR = (lineItemIndex) =>
  `SAVE_CFIA_FIELD_PAYOR_${lineItemIndex}`;

export const TOGGLE_NRCAN = (lineItemIndex) => `TOGGLE_NRCAN_${lineItemIndex}`;
export const TOGGLE_GAC = (lineItemIndex) => `TOGGLE_GAC_${lineItemIndex}`;
export const UPDATE_NRCAN_FIELD = (lineItemIndex) =>
  `UPDATE_NRCAN_FIELD_${lineItemIndex}`;
export const UPDATE_GAC_FIELD = (lineItemIndex) =>
  `UPDATE_GAC_FIELD_${lineItemIndex}`;
export const SAVE_NRCAN_FIELD = (lineItemIndex) =>
  `SAVE_NRCAN_FIELD_${lineItemIndex}`;
export const SAVE_GAC_FIELD = (lineItemIndex) =>
  `SAVE_GAC_FIELD_${lineItemIndex}`;

export const SAVE_PGA_FROM_DETAILS = (lineItemIndex) =>
  `SAVE_PGA_FROM_DETAILS${lineItemIndex}`;

export const INITIALIZE_VALUES_NOTES = "INITIALIZE_VALUES_NOTES";
export const UPDATE_NOTES_ITEM_STATUS = "UPDATE_NOTES_ITEM_STATUS";
export const ADD_NOTES_ITEM = "ADD_NOTES_ITEM";

export const COLLAPSE_LINE_ITEMS = "COLLAPSE_LINE_ITEMS";
export const EXPAND_LINE_ITEMS = "EXPAND_LINE_ITEMS";
export const SHOW_CFIA = "SHOW_CFIA";

export const INIT_HEADER_TAB_WARNINGS = "INIT_HEADER_TAB_WARNINGS";
export const INIT_INVOICE_TAB_WARNINGS = "INIT_INVOICE_TAB_WARNINGS";
export const INIT_LINE_TAB_WARNINGS = "INIT_LINE_TAB_WARNINGS";
export const INIT_PARTIES_TAB_WARNINGS = "INIT_ITEM_TAB_WARNINGS";

export const UPDATE_HEADER_WARNINGS = "UPDATE_HEADER_WARNINGS";
export const REMOVE_HEADER_WARNINGS = "REMOVE_HEADER_WARNINGS";
export const UPDATE_PARTIES_WARNINGS = "UPDATE_PARTIES_WARNINGS";
export const REMOVE_PARTIES_WARNINGS = "REMOVE_PARTIES_WARNINGS";
export const REMOVE_LINE_WARNINGS = "REMOVE_LINE_WARNINGS";
export const REMOVE_WARNING_ON_DELETEION_INVOICE =
  "REMOVE_WARNING_ON_DELETEION_INVOICE";
export const REMOVE_WARNING_ON_DELETEION_MERCH =
  "REMOVE_WARNING_ON_DELETEION_MERCH";
export const UPDATE_LINE_WARNINGS = "UPDATE_LINE_WARNINGS";
export const REMOVE_INVOICE_WARNINGS = "REMOVE_INVOICE_WARNINGS";
export const UPDATE_INVOICE_WARNINGS = "UPDATE_INVOICE_WARNINGS";
export const SAVE_PGA_ON_HTS = "SAVE_PGA_ON_HTS";
export const SAVE_DELTA_UPDATE_STATUS = "SAVE_DELTA_UPDATE_STATUS";


//  Invoice Level Delivery Party 

export const UPDATE_CFIAPGA_FIELDS = 'UPDATE_CFIAPGA_FIELDS'


